import client, { API_BASE_URL } from './client';

// 실시간 메시지 구독(SSE) URL. EventSource 는 Authorization 헤더를 못 실으므로 ?token= 쿼리로 인증한다.
export function adminPushStreamUrl(accessToken) {
  return `${API_BASE_URL}/admin/push/stream?token=${encodeURIComponent(accessToken || '')}`;
}

// 슈퍼관리자 발신. targetType: 'ROLE'(roleCode 대상) | 'ACCOUNT'(account 대상)
export async function sendAdminPush({ targetType, roleCode, account, message, senderName }) {
  const res = await client.post('/admin/push/send', { targetType, roleCode, account, message, senderName });
  return res.data;
}

// 수신자가 '확인'을 누르면 발신자에게 수신확인(누가/언제)을 되돌려 보낸다.
export async function sendAdminAck({ messageId, senderAccount, receiverName }) {
  const res = await client.post('/admin/push/ack', { messageId, senderAccount, receiverName });
  return res.data;
}

// 발송 이력 조회(슈퍼관리자). 최근 100건 + 각 메시지의 수신확인 건수.
export async function getPushHistory() {
  const res = await client.get('/admin/push/history');
  return res.data; // ApiResponse<[{ messageId, targetType, targetRole, targetAccount, message, senderName, sentAt, ackCount }]>
}
